import React, { useState, useEffect, Fragment } from "react";
import ArrowSvg from "../../images/newHome/arrow-top.svg"
import HandSvg from "../../images/newHome/hand.svg"
import ThemeButton from "./ThemeButton";
import SectionTitle from "./SectionTitle";

function ComplianceServicesSection() {

    const items = [
        {
            title: 'Regulatory compliance consulting',
            icon: HandSvg,
            arrow: ArrowSvg,
        },
        {
            title:'Certification management',
            icon: HandSvg,
            arrow: ArrowSvg,
        },
        {
            title:'Technical documentation & audit preparation',
            icon: HandSvg,
            arrow: ArrowSvg,
        },
        {
            title:'Pre-testing evaluations to minimize delays',
            icon: HandSvg,
            arrow: ArrowSvg,
        }
    ];

    return (
        <Fragment>
            <div className="container lg:p-[80px] py-5 px-4 text-center">
                <div className="text-white">
                    <SectionTitle
                        size="font-inter lg:text-5xl text-2xl"
                        weight="font-bold"
                        color="text-white"
                        className="mb-[18px]"
                    >
                        Comprehensive Compliance Services
                    </SectionTitle>
                    <p className="text-lg">From initial consultation to final certification, we handle every step of the compliance process.</p>
                </div>
                <div className="grid grid-cols-2 lg:gap-[40px] gap-[15px] mt-[40px] mb-[58px]">
                    {items.map((item, index) => (
                        <div key={index} className="bg-white px-[24px] py-5 rounded-lg">
                            <div className="float-right">
                                <img src={item.arrow} alt="arrow" />
                            </div>
                            <div className="mt-[12px]">
                                <div className="mb-[40px] bg-iconBg rounded-full h-[83px] w-[83px] flex items-center justify-center">
                                    <img src={item.icon} alt="handSvg" />
                                </div>
                                <p className="max-w-[500px] text-start text-black xl:text-2xl lg:text-lg text-base font-semibold lg:leading-[1]">
                                    {item.title}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
                <div>
                    <ThemeButton
                    bgColor="bg-transparent"
                    textColor="text-white"
                    padding="px-6 py-3"
                    size="text-[18px]"
                    border="border border-white"
                    rounded="rounded-none"
                    className="font-semibold leading-[28px] cursor-pointer"
                    >
                        Get Expert Assistance
                    </ThemeButton>
                </div>
            </div>
        </Fragment>
    );
}

export default ComplianceServicesSection;